import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-632ea257"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "list-unstyled components"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "nav-header" }, "経営情報報告制度（損益計算書）", -1))
const _hoisted_3 = { class: "nav-item" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-export nav-icon" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "出力", -1))
const _hoisted_6 = { class: "nav-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-wrench nav-icon" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "設定", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (!_ctx.shouldSetDate)
    ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("li", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: "/keiei/soneki-keisan/export",
            class: "nav-link"
          }, {
            default: _withCtx(() => [
              _hoisted_4,
              _hoisted_5
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_6, [
          _createVNode(_component_router_link, {
            to: "/keiei/soneki-keisan/setting",
            class: "nav-link"
          }, {
            default: _withCtx(() => [
              _hoisted_7,
              _hoisted_8
            ]),
            _: 1
          })
        ])
      ]))
    : _createCommentVNode("", true)
}